import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingTypeRequest,
  MeetingTypeResponse,
  PageResponse,
} from '../models/meeting.model';

@Injectable({ providedIn: 'root' })
export class MeetingTypeApiService {
  private url = `${environment.apiUrl}api/meeting-types`;
  constructor(private http: HttpClient) {}

  list(
    businessId: number,
    page = 0,
    size = 20
  ): Observable<PageResponse<MeetingTypeResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<MeetingTypeResponse>>(this.url, { params });
  }

  listActive(businessId: number): Observable<MeetingTypeResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingTypeResponse[]>(`${this.url}/active`, { params });
  }

  getById(id: number, businessId: number): Observable<MeetingTypeResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingTypeResponse>(`${this.url}/${id}`, { params });
  }

  create(body: MeetingTypeRequest): Observable<MeetingTypeResponse> {
    return this.http.post<MeetingTypeResponse>(this.url, body);
  }

  update(id: number, body: MeetingTypeRequest): Observable<MeetingTypeResponse> {
    return this.http.put<MeetingTypeResponse>(`${this.url}/${id}`, body);
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }
}
